
    import {
      getAllRuleCertifications,
      createRuleCertification,
      createAllRuleCertifications,
      updateRuleCertification,
      deleteRuleCertification
    } from "@/services/ruleCertification";

    const state = {
      ruleCertifications: [],
      processed: false
    };

    const getters = {
      getRuleCertifications(state) {
        return state.ruleCertifications;
      },
      ruleCertificationProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchRuleCertifications({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllRuleCertifications(
              params
            )
              .then(response => {
                commit("SET_RULECERTIFICATIONS", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createRuleCertification({ commit }, ruleCertification) {
          return new Promise((resolve, reject) => {
            createRuleCertification(ruleCertification)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllRuleCertifications({ commit }, ruleCertifications) {
          return new Promise((resolve, reject) => {
            createAllRuleCertifications(ruleCertifications)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateRuleCertification({ commit }, ruleCertification) {
          return new Promise((resolve, reject) => {
            updateRuleCertification(ruleCertification)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteRuleCertification({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteRuleCertification(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_RULECERTIFICATIONS(state, data) {
        state.ruleCertifications = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    